export const realtorData = {
  email: 'pgtiska@unne.cl',
  phone:' 962183309'
  // email: 'contacto@accionpanal.com',
};
